import type { WavespeedModelConfig } from '../../types';
import { clampTo, hasImageInput } from '../../../tools';

export const reveConfigs: Record<string, WavespeedModelConfig> = {
    'reve/2.1/text-to-image': {
        // https://wavespeed.ai/zh-CN/models/reve/2.1/text-to-image
        apiPath: '/reve/2.1/text-to-image',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, providerOptions } = params;
            return {
                prompt: prompt,
                aspect_ratio: clampTo(aspectRatio || '1:1', ['4:1', '3:1', '21:9', '2:1', '17:9', '16:9', '3:2', '4:3', '5:4', '1:1', '4:5', '3:4', '2:3', '9:16', '1:2', '1:3', '1:4'] as const, '1:1'),
                // 可选参数
                output_format: clampTo(
                    providerOptions?.output_format || 'jpeg',
                    ['jpeg', 'png', 'webp'] as const,
                    'jpeg',
                ),
            };
        },
    },
    'reve/2.1/edit': {
        // 单图: https://wavespeed.ai/zh-CN/models/reve/2.1/edit
        // 多图: https://wavespeed.ai/zh-CN/models/reve/2.1/remix
        apiPath: ({ imageCount }) => imageCount > 1 ? '/reve/2.1/remix' : '/reve/2.1/edit',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, providerOptions } = params;
            return {
                prompt: prompt,
                // 图片 URL
                ...(image_urls.length > 1
                    ? { images: image_urls.slice(0, 8) }
                    : { image: image_urls[0] }),
                aspect_ratio: aspectRatio === 'match'
                    ? undefined
                    : clampTo(aspectRatio || '1:1', ['4:1', '3:1', '21:9', '2:1', '17:9', '16:9', '3:2', '4:3', '5:4', '1:1', '4:5', '3:4', '2:3', '9:16', '1:2', '1:3', '1:4'] as const, '1:1'),
                // 可选参数
                output_format: clampTo(
                    providerOptions?.output_format || 'jpeg',
                    ['jpeg', 'png', 'webp'] as const,
                    'jpeg',
                ),
            };
        },
    },
};